import classNames from 'classnames'
//import { memo, useEffect, useRef, useState } from 'react'
import { memo, useRef } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import salt_48 from '@/assets/salt_48.png'
import Icon from '@/components/Icon/Icon'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
//import cardService from '@/services/card.service'
import { update } from '@/store/cardlists/actions/update'
import { FilterType } from '@/types/additionalFilters'
//import { CardListType } from '@/types/card'
import { groupByModes, sortByModes } from '@/utils/constants'
import { defaultGroupedBy, defaultSortedBy } from '@/utils/constants'
//import { cardListsToNames } from '@/utils/helpers'

import AdditionalFiltersButton from '../AdditionalFilters/AdditionalFiltersButton'
import LockButton from '../LockButton/LockButton'

import styles from './ControlsDesktop.module.scss'

const DropdownItem = (props: any) => {
  const { activeKey, children, ...rest } = props
  const active = activeKey && activeKey === rest.eventKey
  return (
    <Dropdown.Item {...rest}>
      <div className={classNames(styles.inactive, { [styles.active]: active })}>{children}</div>
    </Dropdown.Item>
  )
}

type Props = {
  //cardLists: CardListType[]
  disabledSortMethods?: string[]
  filters: FilterType[]
  groupedBy?: string
  //loading: boolean
  persist: boolean
  setFilters: (filters: FilterType[]) => void
  togglePersist: () => void
  sortedBy?: string
}

const Controls = ({
  //cardLists,
  disabledSortMethods,
  filters,
  groupedBy,
  //loading,
  persist,
  setFilters,
  togglePersist,
  sortedBy,
}: Props) => {
  const dropdownsRef = useRef<HTMLDivElement>(null)
  //const [hovered, setHovered] = useState(false)
  const [theme] = useTheme()

  // // Sneakily fetch cards in the background if we think we need them soon
  // useEffect(() => {
  //   if (hovered) {
  //     if (cardLists && !loading) {
  //       //cardService.getCardMap(cardListsToNames(cardLists))
  //     } else {
  //       setHovered(false)
  //     }
  //   }
  // }, [hovered])

  return (
    <div
      className={classNames(styles.dropdowns, 'shadow-sm')}
      ref={dropdownsRef}
      /* onMouseOver={() => setHovered(true)} */
    >
      <LockButton persist={persist} togglePersist={togglePersist} />
      <div className={styles.dropdown}>
        <label className={styles.label}>
          <Icon icon='clone' />
          {' Group by'}
        </label>
        <DropdownButton
          onSelect={(eventKey) => update({ groupedBy: eventKey as string })}
          size='sm'
          title={groupByModes.find(({ key }) => key === groupedBy)?.value || 'Category'}
          variant={theme}
        >
          {groupByModes.map(({ icon, key, value }) => (
            <DropdownItem activeKey={groupedBy} className={styles.dropdownItem} eventKey={key} key={key}>
              <div className='d-flex'>
                <div className={styles.icon}>{icon && <Icon icon={icon} />}</div>
                <span>{value}</span>
              </div>
            </DropdownItem>
          ))}
          <DropdownItem eventKey={defaultGroupedBy} className={styles.dropdownItem}>
            <div className='d-flex'>
              <div className={styles.icon}></div>
              <span>Reset</span>
            </div>
          </DropdownItem>
        </DropdownButton>
      </div>
      <div className={classNames(styles.dropdown, styles.sortBy)}>
        <label className={styles.label}>
          <Icon icon='arrowDownWideShort' />
          {' Sort by'}
        </label>
        <DropdownButton
          onSelect={(eventKey) => update({ sortedBy: eventKey as string })}
          size='sm'
          title={sortByModes.find(({ key }) => key === sortedBy)?.value || 'Default'}
          variant={theme}
        >
          {sortByModes
            .filter(({ key }) => key !== 'default' && !disabledSortMethods?.includes(key))
            .map(({ icon, key, value }) => (
              <DropdownItem activeKey={sortedBy} className={styles.dropdownItem} eventKey={key} key={key}>
                <div className='d-flex'>
                  <div className={styles.icon}>
                    {key === 'salt' ? (
                      <img className={styles.salt} alt='Salt Score' src={salt_48.src} />
                    ) : (
                      icon && <Icon icon={icon} />
                    )}
                  </div>
                  <span>{value}</span>
                </div>
              </DropdownItem>
            ))}
          <DropdownItem eventKey={defaultSortedBy} className={styles.dropdownItem}>
            <div className='d-flex'>
              <div className={styles.icon}></div>
              <span>Reset</span>
            </div>
          </DropdownItem>
        </DropdownButton>
      </div>
      <div className={classNames(styles.dropdown, styles.cardFilters)}>
        <OverlayTrigger
          overlay={(props) => (
            <Tooltip id='button-tooltip' {...props}>
              <b>Card Filters</b> allow you to filter the displayed cards
            </Tooltip>
          )}
          placement='left' // Must be Left since this can be on the far right of the screen
        >
          <label className={styles.label}>
            <Icon icon='filter' />
            <span className='d-md-none'>&nbsp;Filters</span>
            <span className='d-none d-md-block'>&nbsp;Card Filters</span>
          </label>
        </OverlayTrigger>

        <AdditionalFiltersButton filters={filters} setFilters={setFilters} />
      </div>
    </div>
  )
}

export default memo(Controls)
